import { render, staticRenderFns } from "./MentoringDetails.vue?vue&type=template&id=263466e6&scoped=true&"
import script from "./MentoringDetails.vue?vue&type=script&lang=js&"
export * from "./MentoringDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263466e6",
  null
  
)

export default component.exports